import { render, staticRenderFns } from "./orderTransfer.vue?vue&type=template&id=2212be6e"
import script from "./orderTransfer.vue?vue&type=script&lang=js"
export * from "./orderTransfer.vue?vue&type=script&lang=js"
import style0 from "./orderTransfer.vue?vue&type=style&index=0&id=2212be6e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports